import React from 'react';
import { Pie } from 'react-chartjs-2';
import './chartSetup';
import { useThemeMode } from '../theme';
import { buildPie } from './builders';
import { themePalette } from './palette';

// Pie chart. `data` from charts.prepareCategories [{ label, value }].
export default function PieViz({ data }) {
  useThemeMode();
  const { data: chartData, options } = buildPie(data, themePalette());
  return <Pie data={chartData} options={options} />;
}
